import React from "react";
import { BiBadgeCheck } from "react-icons/bi";

const Backend = () => {
  return (
    <div className="skill__content">
      <h3 className="skills__title">Backend Developer</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">NodeJS</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">
                Express&
                <br />
                MongoDB
              </h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Python</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">MySQL</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Firebase</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Prisma</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Cloudinary</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Typescript</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">PostgreSQL</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">AWS (EC2, S3, Lambda)</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Microsoft Azure</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Docker</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">CI/CD Pipelines</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Playwright</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Scrapy</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Selenium</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Linux Server Administration</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Nginx / Apache</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">WebSockets / Socket.io</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Redis (Caching)</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">MongoDB Atlas</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Database Migrations</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Backend;
